<template>
  <VersionComparator>
    <CompareOther />
  </VersionComparator>
</template>

<script>
import VersionComparator from '@/components/compare/VersionComparator'
import CompareOther from '@/components/expOther/CompareOther'

export default {
  components: {
    CompareOther,
    VersionComparator,
  },
  data: () => ({}),
}
</script>
